import { Component, OnDestroy, OnInit } from '@angular/core';
import * as $ from 'jquery';
window['$'] = window['jQuery'] = $;
import { TranslateService } from "@ngx-translate/core";
import { EmitterService } from '../../../services/emitter.service';
import { AjaxService } from '../../../services/ajax.service';
import { UserDetailsService } from '../../../services/user-details.service';
import { environment } from "../../../../environments/environment";
import { takeUntil } from "rxjs/operators";
import { Subject } from "rxjs";

@Component({
  selector: 'app-dashboard-bonus',
  templateUrl: './dashboard-bonus.component.html',
  styleUrls: ['./dashboard-bonus.component.scss']
})
export class DashboardBonusComponent implements OnInit, OnDestroy {
  bonusAvailable = false;
  userCurrencySymbol;
  bonusDetails;
  mathObj = Math;
  destroy$: Subject<boolean> = new Subject<boolean>();

  constructor(
    private emitterService: EmitterService,
    private ajaxService: AjaxService,
    private translationService: TranslateService,
    public userService: UserDetailsService,
  ) { }
  
  ngOnInit() {
    if(environment.website_code === "NEO"){
      if (!this.userService.getUserCurrencyDetails()) {
        this.ajaxService.getProfileBalanceCurrency().pipe(takeUntil(this.destroy$)).subscribe(profileBalanceCurrency => {
          if (profileBalanceCurrency) {
            this.userCurrencySymbol = profileBalanceCurrency["currencyDetails"].symbol;
          }
        });
      } else {
        this.userCurrencySymbol = this.userService.getUserCurrencyDetails().symbol;
      }
      
      Promise.resolve(this.ajaxService.psGet("", '/ajax/Bonus/activeBonusDetails')).then(data => {
        if (!data) {
          this.bonusAvailable = false;
        } else {
          this.bonusDetails = data;
          this.bonusDetails = this.bonusDetails.filter(bonus=>{
            if(!bonus.isFreeSpinBonus || (bonus.isFreeSpinBonus && bonus.isFreeSpinsCompleted)){
              return bonus;
            }
          })
          this.bonusAvailable = this.bonusDetails.length > 0 ? true : false;
        }
        if (this.bonusAvailable) {
          setTimeout(() => {
            this.setEvent();
          });
        }
      });
    } 
  }
  
  setEvent() {
    $(".top-section-button").off("click").on("click", function () {
      if ($(this).hasClass("activeEle")) {
        //collapse
        $(".bottom-section").slideUp();
        $(".top-section-button").removeClass("activeEle");
        $(".top-section, .bottom-section").removeClass("expandedEle");
      } else {
        //expand
        $(this).addClass("activeEle");
        $(this).parents(".top-section").addClass("expandedEle");
        $(this).parents(".top-section").siblings(".bottom-section").addClass("expandedEle");
        $(this).parents(".top-section").siblings(".bottom-section").slideDown();
      }
    });
  }
  
  ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }
}
